'use client';

import React, { FC, useEffect } from 'react';
import { Trans } from '@tuic/i18n';
import { captureErrorCode } from '@lib/sentry/capture-error-code';
import { ErrorCode } from '@lib/errors/error-code';

type Props = {
  error: ErrorCode;
};

export const Mxp365Error: FC<Props> = ({ error }) => {
  useEffect(() => {
    captureErrorCode(error, 'Mxp365Error');
  }, [error]);

  if (error === ErrorCode.Mxp365NotFound) {
    return (
      <Trans>
        Leider ist dieser Dienst zur Zeit nicht verfügbar.
        <br />
        Bitte versuchen Sie es in ein paar Minuten noch einmal.
        <br />
        Wir bedauern diesen Zustand und danken für Ihr Verständnis!
      </Trans>
    );
  }

  if (error === ErrorCode.Mxp365PersonFromTokenNotFound) {
    return (
      <Trans>
        Solange sich Ihre Buchung im Optionsstatus befindet, werden an dieser
        Stelle keine Inhalte angezeigt.
        <br />
        Handelt es sich bei Ihnen nicht um eine Optionsbuchung, wenden Sie sich
        bitte an Ihre Buchungsstelle.
      </Trans>
    );
  }

  return (
    <Trans>
      Leider haben wir aktuell technische Probleme.
      <br />
      Bitte versuchen Sie es in ein paar Minuten noch einmal.
      <br />
      Wir bedauern diesen Zustand und danken für Ihr Verständnis!
    </Trans>
  );
};
